<template>
  <div class="das-dropdown" :class="{ 'dd-placeholder': !this.selectedTextObj['text'] }" @click.stop="toggleList()">
    <span>
      {{ this.editInput && this.editInput["text"] ? this.editInput["text"] : defaultDropdownText[defaultText] }}
    </span>
    <sup class="red-asterisk" v-if="!this.selectedTextObj['text']">*</sup>
    <span v-if="this.selectedTextObj['object'] && this.selectedTextObj['object']['isSkippable']" class="optional-badge">Optional</span>
    <span class="caret"></span>
    <ul :class="{ 'display-block': showList, 'display-none': !showList }">
      <li class="serach-box-li">
        <div class="search-wrapper">
          <input type="search" v-model="search" placeholder="Search for a step" @click.stop="" />
          <span v-show="search && search.length > 0" @click.stop="clearSearch()" class="search-cross"> </span>
        </div>
      </li>
      <li :class="{ 'display-block': showList, 'display-none': !showList }" v-for="(opt, index) in filteredList" :key="'step-in-activity-' + index" @click.stop="">
        <div class="dropdown-list-item" @click.stop="selectedData(opt)">
          <div>Step {{ opt.stepSequence ? opt.stepSequence : opt.sequence }} - {{ convertCamelCaseToNormalCase(opt.type) }}<span v-if="opt.isSkippable" class="optional-badge">Optional</span></div>
          <div class="step-que text-ellipsis" :class="opt.body.length < 54 ? 'small-width' : 'large-width'" :id="`step-text-${opt.id}-${id}`">
            {{ opt.body }}
          </div>
        </div>
        <b-popover :boundary="'viewport'" :target="`step-text-${opt.id}-${id}`" triggers="hover" placement="right">
          <template v-slot:content>
            <div class="popover-content" :class="opt.body.length < 54 ? 'small-text' : 'large-text'">
              {{ opt.body }}
            </div>
          </template>
        </b-popover>
      </li>
      <li class="dd-placeholder" v-if="!filteredList.length" @click.stop="">
        No available steps
      </li>
    </ul>
  </div>
</template>

<script>
import { cloneDeep, find } from "lodash";

const STEP_TYPES = [
  { value: "CustomScale", label: "Custom scale", facingType: "both" },
  { value: "DateTime", label: "Date / Time", facingType: "both" },
  { value: "DropDown", label: "Drop-down", facingType: "both" },
  {
    value: "GPSkin",
    label: "gpskin Barrier device scan",
    facingType: "participant"
  },
  { value: "ImageCapture", label: "Image capture", facingType: "participant" },
  { value: "Index", label: "Index", facingType: "site" },
  { value: "Log", label: "Log Entry", facingType: "site" },
  { value: "Measurements", label: "Measurements", facingType: "site" },
  {
    value: "MedicationSelector",
    label: "Medication Selector",
    facingType: "participant"
  },
  { value: "MultiChoice", label: "Multiple choice", facingType: "both" },
  { value: "Number", label: "Number Response", facingType: "both" },
  { value: "NumberScale", label: "Number Scale", facingType: "both" },
  { value: "Text", label: "Text Response", facingType: "both" },
  { value: "ValidatedEntry", label: "Validated Entry", facingType: "site" },
  { value: "VAS", label: "Visual analog scale", facingType: "participant" },
  { value: "Boolean", label: "Yes or No", facingType: "both" }
];

export default {
  name: "dropdown-step-in-activity",
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      }
    },
    optionField: {
      type: String,
      default: ""
    },
    defaultText: {
      type: String,
      default: null
    },
    valueField: {
      type: String,
      default: ""
    },
    input: {
      type: String,
      default: null
    },
    id: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      defaultDropdownText: {
        trigger: "Select Trigger",
        selectStep: "Select Step",
        milestone: "Select Milestone(s)",
        language: "Select Language(s)",
        birthDate: "Select a Date",
        country: "Select a Country",
        gender: "Select Gender",
        taskDetails: "Select an Activity"
      },
      showList: false,
      selectedTextObj: { text: null, object: null },
      selectedDataArr: [],
      optionsListContainingEnabledStepTypesOnly: [],
      search: ""
    };
  },
  created() {
    this.$root.$on("close-all-drop-downs", data => {
      if (data == "all" || data == "multi-select" || data != this.id) {
        this.showList = false;
      }
    });
  },
  methods: {
    toggleList() {
      this.showList = !this.showList;
      this.$root.$emit("close-all-drop-downs", this.id); // this will close only single dropdown( single )
    },
    selectedData(data) {
      this.showList = false;
      this.clearSearch();
      this.$emit("selected-data", data);
    },
    convertCamelCaseToNormalCase(str) {
      const step = STEP_TYPES.filter(step => {
        return step.value === str;
      });
      return step && step[0] && step[0].label;
    },
    clearSearch() {
      this.search = "";
      this.filteredList = cloneDeep(this.optionsListContainingEnabledStepTypesOnly);
    },
    updateSelectedText() {
      this.selectedTextObj["text"] = "";
      if (this.input) {
        const selectedObj = find(this.optionsListContainingEnabledStepTypesOnly, [this.valueField, this.input]);
        const stepSequence = selectedObj && selectedObj.stepSequence ? selectedObj.stepSequence : selectedObj.sequence;
        this.selectedTextObj["text"] = selectedObj && `Step ${stepSequence} - ${this.convertCamelCaseToNormalCase(selectedObj.type)}`;
        this.selectedTextObj["object"] = selectedObj;
      }
    }
  },
  computed: {
    filteredList: {
      get() {
        return this.optionsListContainingEnabledStepTypesOnly.filter(opt => {
          const stepSequence = opt && opt.stepSequence ? opt.stepSequence : opt.sequence;
          const text = `Step ${stepSequence} - ${STEP_TYPES.find(o => o.value === opt.type).label}`;
          const textAvailable = text && text.toLowerCase().indexOf(this.search && this.search.toLowerCase()) > -1;
          const stepBodyAvailable = opt["body"] && opt["body"].toLowerCase().indexOf(this.search && this.search.toLowerCase()) > -1;
          return textAvailable || stepBodyAvailable;
        });
      },
      set(value) {
        /* this setter is only used because, otherwise this computed property was giving error, it has no other role to play */
        this.selectedDataArr = value;
      }
    },
    editInput() {
      this.updateSelectedText();
      return this.selectedTextObj;
    }
  },
  watch: {
    options: {
      deep: true,
      immediate: true,
      handler: function(newV) {
        if (newV && newV.length) {
          this.optionsListContainingEnabledStepTypesOnly = newV.filter(step => {
            for (const s of STEP_TYPES) {
              if (step.type === s.value) {
                return step;
              }
            }
          });
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.display-block {
  display: block;
}

.display-none {
  display: none;
}

.dd-placeholder {
  color: #b0bac9 !important;
  font-size: 13px;
  padding: 7px 17px !important;
  font-weight: normal;
}

.text-ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
}

.small-width {
  display: inline;
  padding-right: 5px;
}

.large-width {
  width: 100%;
  display: block;
}

.das-dropdown {
  border: solid 1px #d3dfe4;
  padding: 6px 17px;
  border-radius: 3px;
  position: relative;
  cursor: pointer;
  margin-bottom: 15px;

  .red-asterisk {
    color: #f16559;
    font-size: 14px;
    font-weight: bold;
    top: -0.2em;
  }

  .optional-badge {
    background: #d3dfe4;
    padding: 2px 6px 3.6px 6px;
    border-radius: 4px;
    color: #ffffff;
    font-size: 10px;
    margin-left: 4px;
    font-weight: 500;
  }

  .caret {
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 6px solid #b0bac9;
    top: 14px;
    right: 7px;
    position: absolute;
  }

  ul {
    font-family: RobotoRegular;
    font-size: 15px;
    margin: 0;
    padding: 6px 0;
    list-style: none;
    position: absolute;
    z-index: 9;
    top: 0;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
    background: #fff;
    left: 0;
    box-shadow: 0 1px 0px 0 rgba(230, 230, 230, 2%), 0 1px 9px 0 rgba(230, 230, 230, 100%);

    li {
      display: block;
      text-decoration: none;
      color: #000;
      /* border-top: 1px solid #ffffff; */
      padding: 5px 15px 5px 15px;
      background: #ffffff;
      margin-left: 1px;
      white-space: nowrap;

      input[type="checkbox"] {
        box-sizing: border-box;
        cursor: pointer;
        padding: 0;
        margin-right: 11px;
        margin-top: auto;
        margin-bottom: auto;
        top: 2px;
        bottom: 0px;
        position: relative;
        width: 16px;
        height: 16px;
        border-radius: 4px;
        outline: solid 1px #e2e7ea;
        border: none;
      }

      &.serach-box-li {
        &:hover {
          background: rgba(0, 0, 0, 0);
        }
      }

      .search-wrapper {
        border: solid 1px #b0bac9;
        width: 100%;
        border-radius: 4px;
        padding: 3px 8px;
        display: flex;
        flex-wrap: nowrap;
        position: relative;

        input[type="search"] {
          border: none;
          width: 100%;
        }

        .search-cross {
          background: url(/static/img/search-cross.svg) no-repeat;
          display: block;
          height: 16px;
          width: 16px;
          top: 7px;
          position: absolute;
          right: 4px;
        }
      }

      .dropdown-list-item {
        font-size: 14px;
        margin-left: 8px;
        -webkit-font-smoothing: antialiased;

        .optional-badge {
          background: #c5d1d6;
          padding: 2px 6px 3.6px 6px;
          border-radius: 4px;
          color: #ffffff;
          font-size: 9px;
          margin-left: 3px;
          font-weight: 600;
        }

        .step-que {
          font-size: 12px;
        }
      }

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }

  ul::-webkit-scrollbar {
    height: 3px;
  }

  ul::-webkit-scrollbar-thumb {
    background-color: #c4c4c4;
    border-radius: 4px;
    height: 3px;
    border: 3px solid transparent;
  }

  ul::-webkit-scrollbar-track {
    background: transparent;
  }

  ul::-webkit-scrollbar {
    width: 4px;
  }
}

.popover-content {
  font-size: 13px;
  font-family: "RobotoRegular";
  color: #000;

  &.small-text {
    margin: 2px 1px;
  }

  &.large-text {
    margin: 6px 7px;
  }
}
</style>
